/*     标准代码提供者
 归属：企通前端平台-ECP V5.1
 版权：2014-2020 企通软件技术有限公司
 --------------------------------------------------------------------------------
 作者：纪青君                         创建日期：2014/03/13
 修改：                               修改日期：
 修改内容
 --------------------------------------------------------------------------------
 这里向使用者提供根据代码ID，获得代码的方法getSC(scID)
 scID 符合XXXX,xx`xx`xx...的定义规则
 输入参数scID包含的项不同，你得到的结果也不同，例如：
 getSC（XXXX），你可能得到的是一个代码数组或代码树。
 getSC(XXXX,xx)，你可能得到的是一个具体的代码值，也可能你得到的还是一个代码
 数组或代码树，这样依据你的代码结构而定。
 
 !!!! 目前采用程序直接量的方式定义各种代码，最终将改为从参数中读取，但对外接口将保持不变
 --------------------------------------------------------------------------------
 修改： liux                              修改日期：2014/04/30
 修改内容
 getSC方法修改为使用参数工厂从参数库中读取一个代码。
 指定的scID可以使一个代码参数的GUID，也可以是某个代码参数中的任意子节点的sGUID。
 但是该方法返回的是参数的json形式对象或json对象的数组,而不是一个model对象。
 --------------------------------------------------------------------------------
 //0XXX：控件公共信息
 //1XXX：容器控件
 //2XXX：基本控件
 //3XXX：自定义控件
 //4XXX：布局属性
 //5XXX: 图形控件
 //6XXX—8XXX:保留
 //9XXX:公共
 
 *******************************************************************************/
import { PrmFactory } from './PrmFactory';
import { Resource } from './Resource';
import sgiLogger from '../sgiCommon/sgiLogger';
import { itemForEach } from '../sgiCommon/sgiCommon';
// var this.SCMap = {};

/**
 * @namespace 标准代码管理器
 */
let StandardCode = {

	SCMap: {},
	onChangeMap: {},

	/**
	 * 获取标准代码下拉项
	 * @param {string} scID 标准代码guid
	 */
	getSC: function (scID) {
		sgiLogger.debug_1(`标准代码管理器[StandardCode]-获取标准代码[getSC]: scID=[${scID}]`);
    	/**
        if (!scID) {
            return null;
        }
        if (typeof (scID) != "string") {
            return null;
        }
        var sc = Ep.this.SCMap.get(scID);
        if (!sc) {
            sc = Ep.PrmFactory.getPrmJsonNoLocal(scID);
            if (!sc) {
                return null;
            } else {
                sc.te = Ep.getTR(sc.te).te;
                Ext.each(sc.cldSet, function(record) {
                    record.te = Ep.getTR(record.te).te;
                });
                Ep.this.SCMap.add(scID, sc);
            }
        }
        **/
		var sc = this.getFullSC(scID);

		if (!sc) {
			return null;
		}

		if (sc.cldSet) {
			return sc.cldSet;
		} else {
			sc.cldSet = [];
			return sc.cldSet;
		}
	},
	/**
	 * 获取标注代码参数（包含根节点）
	 * @param {string} scID 标准代码guid
	 */
	getFullSC: function (scID) {
		sgiLogger.debug_1(`标准代码管理器[StandardCode]-获取完整标准代码[getFullSC]: scID=[${scID}]`);
		if (!scID) {
			return null;
		}
		if (typeof (scID) != "string") {
			return null;
		}
		var sc = this.SCMap[scID];
		if (!sc) {
			sc = PrmFactory.getPrm(scID);
			if (!sc) {
				return null;
			} else {
				sc.te = Resource.getTRByPrm(sc).te;//Resource.getTR(sc.te).te;
				var array = sc.cldSet;
				if (array instanceof Array && array.length > 0) {
					array.forEach((record) => {
						record.te = Resource.getTRByPrm(record).te;//Resource.getTR(record.te).te;
					});
				} else if (sc.initFun) {
					let initFun = sc.initFun;
					try {
						let reg = new RegExp(/console/gi);
						initFun = initFun.replace(reg, "tool.sgiLogger");
						let init = new Function(initFun);
						let dataObj = init() || {};
						if (dataObj.data) {
							let codeCode = dataObj.code || "c";
							let textCode = dataObj.text || "te";
							let childName = dataObj.childName || "cldSet";
							let data = dataObj.data;
							if (codeCode !== "c" || textCode !== "te" || childName !== "cldSet") {
								// 对数据进行处理
								itemForEach(data, item => {
									if (codeCode !== "c" && item[codeCode]) item.c = item[codeCode];
									if (textCode !== "te" && item[textCode]) item.te = item[textCode];
									if (childName !== "cldSet" && item[childName]) item.cldSet = item[childName];
								});
							}
							sc.cldSet = data;
						}
					} catch (error) {
						sgiLogger.eventErr(error);
					}
				}
				// sgiLogger.debug('StandardCode SCMap old:', this.SCMap);
				this.SCMap[scID] = sc;
				// sgiLogger.debug('StandardCode SCMap new:', this.SCMap);
			}
		}
		if (sc) {
			return sc;
		} else {
			return {};
		}
	},
	/**
	 * 判断是否存在下拉内容
	 * @param {string} scID 标准代码guid
	 * true-下拉项数量大于0
	 * false-标准代码不存在|下拉项数量=0
	 */
	contains: function (scID) {
		sgiLogger.debug_1(`标准代码管理器[StandardCode]-判断下拉项[contains]: scID=[${scID}]`);
		var scList = this.getSC(scID);
		if (!scList) {
			return false;
		}
		if (scList.length > 0) {
			return true;
		} else {
			return false;
		}
	},
	/**
	 * 删除标准代码缓存
	 * @param {string} scID 标准代码guid
	 */
	delSC: function (scID) {
		sgiLogger.debug_1(`标准代码管理器[StandardCode]-删除标准代码[delSC]: scID=[${scID}]`);
		if (!scID) {
			return null;
		}
		delete this.SCMap[scID];
	},
	/**
	 * 设置标准代码缓存参数
	 * @param {string} scID 标准代码guid
	 * @param {object} sc 标准代码参数
	 */
	setSC: function (scID, sc) {
		sgiLogger.debug_1(`标准代码管理器[StandardCode]-设置标准代码[setSC]: scID=[${scID}], 标准代码内容sc=【${JSON.stringify(sc)}】`);
		if (!scID) {
			return null;
		}
		var oldSc = this.SCMap[scID];
		if (!oldSc) {
			// this.SCMap.removeAtKey(scID);
			delete this.SCMap[scID];
		}
		// sgiLogger.debug('StandardCode SCMap old:', this.SCMap);
		this.SCMap[scID] = sc;
		this.onSCChange(scID);
		// sgiLogger.debug('StandardCode SCMap new:', this.SCMap);
	},
	/**
	 * 重载标准代码
	 * @param {string} scID 标准代码guid
	 */
	reloadSC: function (scID) {
		sgiLogger.debug_1(`标准代码管理器[StandardCode]-重载标准代码[reloadSC]: scID=[${scID}]`);
		if (!scID) return;
		this.delSC(scID);
		this.getFullSC(scID);
		this.onSCChange(scID);
	},
	onSCChange: function (scID) {
		sgiLogger.debug_1(`标准代码管理器[StandardCode]-标准代码修改[onSCChange]: scID=[${scID}]`);
		let scOnChanges = this.onChangeMap[scID];
		if (scOnChanges && scOnChanges.length > 0) {
			// 执行标准代码修改回调
			scOnChanges.forEach(f => {
				setTimeout(() => {
					try {
						sgiLogger.debug(`标准代码[${scID}]修改，执行控件订阅事件`);
						f(this.SCMap[scID].cldSet);
					} catch (error) {
						sgiLogger.eventErr(error);
					}
				}, 0);
			});
		}
	},
	subscribe: function (scID, callback) {
		sgiLogger.debug_1(`标准代码管理器[StandardCode]-订阅标准代码[subscribe]: scID=[${scID}], 订阅回调事件=【${JSON.stringify(callback)}】`);
		// 校验
		if (!scID || !callback || typeof callback !== "function") return;
		// 添加订阅事件
		let onChanges = this.onChangeMap[scID];
		if (!onChanges) onChanges = this.onChangeMap[scID] = [callback];
		else if (onChanges.indexOf(callback) < 0) onChanges.push(callback);
		// 返回取消订阅的方法
		return function unsubscribe() {
			onChanges.splice(onChanges.indexOf(callback), 1);
		};
	}
}

// 初始化
if (!window.StandardCode) window.StandardCode = StandardCode;
// 添加方法
else Object.assign(window.StandardCode, StandardCode);
// 导出
let wStandardCode = window.StandardCode;
export { wStandardCode as StandardCode };
export default wStandardCode;


// WEBPACK FOOTER //
// ./~/rt-sd-common/sgiFactory/StandardCode.js